import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { useTranslation } from "react-i18next";
import { GrNext, GrPrevious } from "react-icons/gr";
import { useSelector } from "react-redux";
import axios from "axios";
import { NavLink } from "react-router-dom";

export const WrittenPress = () => {
  const { t } = useTranslation();
  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const [isLoading, setIsLoading] = useState(true);
  const [press_w, setPress_w] = useState(null);
  const [error, seterror] = useState(null);
  const swiperRef = useRef();
  const navigationRefs = useRef({});

  useEffect(() => {
    const fetchWrittenPress = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`${baseUrl}/press_written`);
        setPress_w(response.data.press);
      } catch (err) {
        console.error(err);
        seterror(err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchWrittenPress();
  }, [baseUrl]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="w-9 h-9 border-4 border-black border-l-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!press_w || press_w.length === 0) {
    return (
      <div className="flex justify-center items-center h-full">
        <h3 className="text-xl text-gray-400">No media yet</h3>
      </div>
    );
  }

  return (
    <div>
      <h1
        id="Written"
        className="text-3xl lg:text-5xl md:text-4xl text-center mb-[3rem] presse custom-font"
      >
        {t("media.press.WrittenPress")}
      </h1>

      <div className="p-12 lg:px-[10rem] lg:mb-[5rem]  md:px-[10rem] md:mb-[5rem]">
        <div className="relative">
          <button className="customm-prev absolute top-1/2 left-[-45px] lg:left-[-65px] md:left-[-65px] transform -translate-y-1/2 z-10 text-2xl rounded-full text-black p-4 bg-white shadow-md hover:bg-[#119f04] hover:text-white transition-all">
            <GrPrevious />
          </button>

          <Swiper
            spaceBetween={25}
            loop={true}
            breakpoints={{
              0: { slidesPerView: 1, spaceBetween: 20 },
              680: { slidesPerView: 2, spaceBetween: 15 },
              1024: { slidesPerView: 2, spaceBetween: 20 },
              1100: { slidesPerView: 2 },
              1200: { slidesPerView: 3 },
            }}
            navigation={{
              prevEl: ".customm-prev",
              nextEl: ".customm-next",
            }}
            modules={[Navigation, Pagination, Autoplay]}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            className="w-full"
          >
            {press_w.map((item) => {
              if (!navigationRefs.current[item.id]) {
                navigationRefs.current[item.id] = {
                  prevRef: React.createRef(),
                  nextRef: React.createRef(),
                };
              }

              return (
                <SwiperSlide key={item.id}>
                  <div className="border border-black p-3 h-full">
                    <div
                      className="relative h-[400px]  lg:h-[400px] md:h-[300px] sm:h-[300px]"
                      style={{
                        backgroundImage: `url(${item.thumbnail})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      <div className="absolute bottom-0 left-0 w-full text-white p-4">
                        <div className="absolute inset-0 bg-black opacity-60"></div>
                        <div className="relative z-10 flex flex-col gap-1 sm:gap-2 items-start">
                          <NavLink
                            to={item.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-xs sm:text-sm md:text-10px bg-[#046f29] px-2 py-1 sm:px-3 sm:py-2 rounded-sm custom-font uppercase transition-all duration-200"
                          >
                            {item.name}
                          </NavLink>
                          <h3 className="text-xs sm:text-sm md:text-base font-semibold custom-font uppercase">
                            {item.title}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>

          <button className="customm-next absolute top-1/2 right-[-45px] lg:right-[-65px] md:right-[-65px] transform -translate-y-1/2 z-10 text-2xl rounded-full text-black p-4 bg-white shadow-md hover:bg-[#119f04] hover:text-white transition-all">
            <GrNext />
          </button>
        </div>
      </div>
    </div>
  );
};
